import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import styles from "./EventDetails.module.css";
import API_BASE_URL from "../../config/api";

const EventDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/fetchEvents.php?id=${id}`);
        // console.log("Event details:", response.data);
        setEvent(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching event details:", err);
        setError("Failed to fetch event details");
        setLoading(false);
      }
    };

    fetchEventDetails();
  }, [id]);

  if (loading) return <div className={styles.loading}>Loading event details...</div>;
  if (error) return <div className={styles.error}>{error}</div>;
  if (!event) return <div className={styles.error}>Event not found</div>;

  // 判断事件是否已结束
  const isEventEnded = () => {
    if (!event.end_date) return false;
    const today = new Date();
    const endDate = new Date(event.end_date);
    return endDate < today;
  };

  const eventEnded = isEventEnded();

  // 确保 event.details 是数组
  const eventDetails = Array.isArray(event.details) ? event.details : [];

  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <h1 className={styles.title}>Event</h1>
        <button onClick={() => navigate(-1)} className={styles.backButton}>
          Back
        </button>
      </div>

      {/* Divider */}
      <hr className={styles.divider} />

      {/* Event Details */}
      <div className={styles.detailsRow}>
        <h2 className={styles.eventName}>{event.name}</h2>
        <p className={styles.eventPeriod}>Event period: {event.event_period}</p>
      </div>

      {/* Event Ended Message */}
      {eventEnded && (
        <div className={styles.endedMessage}>This event has ended.</div>
      )}

      {/* Event Content */}
      <div className={styles.eventContent}>
        {eventDetails.length > 0 ? (
          eventDetails.map((detail, index) => (
            <div key={index} className={styles.detailItem}>
              {detail.type === "image" ? (
                <div className="detailImg">
                  <img
                    src={`${API_BASE_URL}/uploads/eventDetailsImages/${detail.content}`}
                    alt={`Event detail ${index + 1}`}
                    className={`${styles.detailImage} ${
                      eventEnded ? styles.grayedOutImage : ""
                    }`}
                  />
                </div>
              ) : (
                <p className={styles.detailText}>{detail.content}</p>
              )}
            </div>
          ))
        ) : (
          <p className={styles.noDetails}>No details available for this event.</p>
        )}
      </div>
    </div>
  );
};

export default EventDetails;